import $ from "jquery";
export const stopPropagation = {
    init: () => {
        stopPropagation.enableGlobal();
        $("[data-stop-propagation]").each(function () {
            const $thisElement = $(this);
            $thisElement.on("click", function (event) {
                event.stopPropagation();
            });
        });
    },
    enableGlobal: () => {
        if (!window["stopPropagation"]) {
            window["stopPropagation"] = stopPropagation;
        }
    },
};
